<template>
  <div class="col-4 col-md-3 col-lg-2   p-1 my-1 d-flex">
    <div class="card w-100 d-flex">
      <a :href="member.clickUrl" target="_blank">
        <img  v-if="member.imageUrl" class="card-img-top" :src="member.imageUrl">
      </a>
      <div class="card-body px-1">
        <h5 class="card-title">{{member.name}}</h5>
        <p v-if="member.signup" class="card-text" >{{signupTime}}</p>
        <p class="card-text"  :class="{'mb-1': member.subtTeam }" >{{member.group + " " + member.team}}</p>
        <p v-if="member.subtTeam" class="card-text">{{member.subtTeam}}</p>
      </div>
    </div>

  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: "",
  props: ['member'],
  data: () => ({

  }),
  computed: {
    signupTime: function(){
      return moment(this.member.signupTime).format('MM/DD HH:mm')
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Member.vue